/**
 * @enum {enumThemeType} An enumeration of the different basic types of themes
 */
export enum enumThemeType {
  BuiltIn = 'BuiltIn', // Built-in theme type
  Custom = 'Custom' // Custom theme type
}
